import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { ErrorItemText } from '../ErrorsPresenter/ErrorsPresenter';
import { TextInputDecorator } from '../TextInputDecorator/TextInputDecorator';

import './PhrasePriceEditor.css';
import * as keyset from './PhrasePriceEditor.i18n';

const i18n = i18nFactory(keyset);

export interface PhrasePriceEditorProps {
    error?: ErrorItemText;
    price?: string;
    onChange: (val: string) => void;
    currency: string;
}

const BLOCK = 'phrase-price-editor';

export class PhrasePriceEditor extends React.Component<PhrasePriceEditorProps, {}> {
    render() {
        const { error, price, onChange, currency } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                <div className={Bem.cls(BLOCK, 'price-content')}>
                    <TextInputDecorator
                        theme="normal"
                        size="m"
                        view="classic"
                        cls={Bem.cls(BLOCK, 'money-input')}
                        valid={!error}
                        text={price}
                        autoFocus={true}
                        onChange={onChange}
                    />

                    <span className={Bem.cls(BLOCK, 'currency')}>{mapStringToCurrencySymbol(currency)}</span>
                    <div className={Bem.cls(BLOCK, 'hint')}>{i18n('adjustments-rate')}</div>
                </div>

                <div className={classNames(Bem.cls(BLOCK, 'error'), TestBem.cls(BLOCK, 'error'))}>{error}</div>
            </div>
        );
    }
}
